import { render, staticRenderFns } from "./DriverOrgReport.vue?vue&type=template&id=64cc6c52&scoped=true&"
import script from "./DriverOrgReport.vue?vue&type=script&lang=js&"
export * from "./DriverOrgReport.vue?vue&type=script&lang=js&"
import style0 from "./DriverOrgReport.vue?vue&type=style&index=0&id=64cc6c52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc6c52",
  null
  
)

export default component.exports